import { Box } from "@twilio-paste/core/box";
import { Button } from "@twilio-paste/core/button";
import { Text } from "@twilio-paste/core/text";
import { FormEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { notifications } from "../notifications";
import { contactBackend, sessionDataHandler } from "../sessionDataHandler";
import { addNotification, changeEngagementPhase } from "../store/actions/genericActions";
import { initSession } from "../store/actions/initActions";
import { AppState, EngagementPhase } from "../store/definitions";
import { Loading } from "./Loading";
import { formStyles } from "./styles/PreEngagementFormPhase.styles";

export const PreEngagementFormPhase = () => {
    const sessionData = useSelector((state: AppState) => state.config.sessionData) || {};
    const dispatch = useDispatch();

    const [isAvailable, setAvailable] = useState<boolean | null>(null);
    useEffect(() => {
        contactBackend<{ available: boolean }>("/availability").then((body) => setAvailable(body.available));
    }, []);

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        dispatch(changeEngagementPhase({ phase: EngagementPhase.Loading }));
        try {
            const data = await sessionDataHandler.fetchAndStoreNewSession({
                formData: {
                    ...sessionData
                }
            });
            dispatch(initSession({ token: data.token, conversationSid: data.conversationSid }));
        } catch (err) {
            dispatch(addNotification(notifications.failedToInitSessionNotification((err as Error).message)));
            dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
        }
    };

    if (isAvailable === null) {
        return <Loading />;
    } else if (isAvailable) {
        return (
            <Box as="form" data-test="pre-engagement-chat-form" onSubmit={handleSubmit} {...formStyles}>
                <Button variant="primary" type="submit" data-test="pre-engagement-start-chat-button">
                    Start chat
                </Button>
            </Box>
        );
    }
    return (
        <Box data-test="pre-engagement-chat-form" {...formStyles}>
            <Text as="p">
                No Anti-Trafficking Hotline Advocates are currently available. Please call 1-888-373-7888 or text BEFREE
                (233733).
            </Text>
        </Box>
    );
};
